@if (banner?.isShow) {
    <div
        class="flex p-4 bg-(--p-warm-gray-300)"
        [ngClass]="{ 'banner-important': banner?.isImportant }"
    >
        <div class="mx-2 my-1">
            <i class="pi pi-info-circle text-red-600"></i>
        </div>
        <div class="mx-1 grow">
            <div class="font-bold">{{ banner?.title }}</div>
            <div>{{ banner?.information }}</div>
        </div>
        <p-button
            icon="pi pi-times"
            variant="text"
            severity="secondary"
            (click)="banner!.isShow = false"
        />
    </div>
}
